module.exports = __webpack_public_path__ + "static/media/LogoGoogle2.e7753310.png";